import _ from "underscore";
import { isNotEmpty } from "../framework/utils";
import { optional, walk } from "./lang";

export function getItem(menu, itemId) {
    let item;

    walk(menu, "children", i => {
        if (i.id === itemId) {
            item = i;
        }
    })

    return item;
}

export function getItemRoot(menu, itemId) {
    const item = getItem(menu, itemId);
    let root;
    if (isNotEmpty(item)) {
        _.each(menu, branch => {
            let hasItem;
            if (branch.id === itemId) {
                hasItem = true;
            } else {
                walk(optional(branch.children, []), "children", i => {
                    if (i.id === itemId) {
                        hasItem = true;
                    }
                })
            }
            if (hasItem) {
                root = branch;
            }
        })
    }
    return root;
}

export function getMenuLevel(menu, itemId) {
    let itemFound = false,
        menuLevel = 0;
    const checkItems = (items) => {
            if (_.chain(items).pluck("id").contains(itemId).value()) {
                itemFound = true;
            } else {
                const children = _.chain(items)
                    .map(i => optional(i.children, []))
                    .flatten(1)
                    .value();
                if (isNotEmpty(children)) {
                    menuLevel += 1;
                    checkItems(children);
                }
            }
        }

    checkItems(menu);
    return itemFound ? menuLevel : undefined;
}